import React from "react";
import PieChart from "./PieChart";
import { ChartsBlock } from "./Counter/CountersBlock.elements";

const PieCharts = (props) => {
  const resolutionData = [
    { id: "resolution4K", label: "4K", value: props.stats.resolution4K || 0, color: "#3E79BD" },
    { id: "resolutionHDPlus", label: "HD+", value: props.stats.resolutionHDPlus || 0, color: "#F15E6B" },
    { id: "resolutionHD", label: "<HD", value: props.stats.resolutionHD || 0, color: "#8095B7" },
  ];

  const typeData = [
    { id: "commercialClips", label: "commercial", value: props.stats.commercialClips || 0, color: "#5D62B6" },
    { id: "editorialClips", label: "editorial", value: props.stats.editorialClips || 0, color: "#BC96DF" },
  ];

  return (
      <ChartsBlock>
        <PieChart data={resolutionData} />
        <PieChart data={typeData} />
      </ChartsBlock>
  );
};

export default PieCharts;
